// extracted by mini-css-extract-plugin
export default {"hero-container":"Hero_hero-container__Zv8QV","hero-bg-img":"Hero_hero-bg-img__jD6k7","hero-text":"Hero_hero-text__Jnt9h","hero-btn":"Hero_hero-btn__ydnGE"};